import { Utils, Debug, Request, ExpireData, ReduxData } from '@lib/hlibs';

const cacheTimeSec = 60 * 5;

class Config extends ReduxData
{
    static create = (name) => new Config(name);

    async getAsync(key)
    {
        if(!key) return null;

        let config = super.getState('config') || {};

        if(config[key])
        {
            const data = ExpireData.readData(config[key]);

            if(data) return data;
        }

        try
        {
            const { data } = await Request.get('/config/get', { key });
    
            if(Utils.checkKeyExists(data, ['value']))
            {   
                config[key] = data?.value ? ExpireData.makeData(data?.value, cacheTimeSec) : null;
    
                super.set(config, 'config');

                return data?.value;
            }    
        }
        catch(e)
        {
            if(process.env.MODE !== 'RELEASE') Debug.exception(e);
        }

        return null;
    }

    async setAsync(key, value, memo = null)
    {
        try
        {
            const { data } = await Request.post('/config/set', { key, value, memo });
    
            if(data?.result == true)
            {   
                let config = super.getState('config') || {};
    
                config[key] = value ? ExpireData.makeData(value, cacheTimeSec) : null;
    
                super.set(config, 'config');

                return true;
            }    
        }
        catch(e)
        {
            if(process.env.MODE !== 'RELEASE') Debug.exception(e);
        }

        return false;
    }
};

const reduxModule = Config.create("Config");

export default reduxModule;